import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getPublishedPosts } from '../services/blogService';
import './BlogPage.css';

function formatDate(ts) {
  if (!ts) return '';
  const d = ts.toDate ? ts.toDate() : new Date(ts.seconds * 1000);
  return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}

export default function BlogPage() {
  const navigate = useNavigate();
  const [posts, setPosts] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    getPublishedPosts()
      .then(setPosts)
      .catch(() => setError('Failed to load posts. Please try again.'));
  }, []);

  return (
    <div className="blog-page">
      <nav className="blog-nav">
        <button className="blog-nav-back" onClick={() => navigate('/')}>← Back</button>
        <span className="blog-nav-logo display-font">World Cup Pick'em</span>
      </nav>

      <div className="blog-content">
        <h1 className="blog-title display-font">What's New</h1>

        {error && <div className="blog-error">{error}</div>}

        {posts === null && <div className="blog-loading">Loading…</div>}

        {posts && posts.length === 0 && (
          <div className="blog-empty">No posts yet — check back soon.</div>
        )}

        {posts && posts.length > 0 && (
          <div className="blog-list">
            {posts.map((post) => (
              <div
                key={post.id}
                className="blog-card"
                onClick={() => navigate(`/blog/${post.id}`)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && navigate(`/blog/${post.id}`)}
              >
                <div className="blog-card-date">{formatDate(post.publishedAt)}</div>
                <h2 className="blog-card-title">{post.title}</h2>
                {post.excerpt && <p className="blog-card-excerpt">{post.excerpt}</p>}
                <span className="blog-card-read">Read more →</span>
              </div>
            ))}
          </div>
        )}
      </div>

      <footer className="blog-footer">
        <span className="blog-footer-copy">© 2026 World Cup Pick'em</span>
        <div className="blog-footer-links">
          <button className="blog-footer-link" onClick={() => navigate('/terms')}>Terms of Service</button>
          <span>·</span>
          <button className="blog-footer-link" onClick={() => navigate('/privacy')}>Privacy Policy</button>
        </div>
      </footer>
    </div>
  );
}
